import { SupportingActorType } from '@dadohr/shared/domainTypes/experience';
import { InfoBox } from '../../../../../../../components/InfoBox';
import { useUnsafeTranslation } from '../../../../../../../i18next';
import type { ActorTypeForm, SubtaskActorState } from '..';

const SubtaskActorFields = () => {
  const { t } = useUnsafeTranslation();
  return (
    <InfoBox color="blue" fullWidth>
      {t(
        'Use an Assign Supporting Actor sub-task to assign this role during the course of the experience.'
      )}
    </InfoBox>
  );
};

/** "Assigned by subtask": an Assign Supporting Actor sub-task picks the person. */
export const subtaskActorType: ActorTypeForm<SubtaskActorState> = {
  option: SupportingActorType.ASSIGNED_BY_SUBTASK,
  label: (t) => t(`Assigned by subtask`),
  matches: (actor) => actor.type === SupportingActorType.ASSIGNED_BY_SUBTASK,
  fromActor: (actor, defaultColor) => ({
    name: actor.name || '',
    type: SupportingActorType.ASSIGNED_BY_SUBTASK,
    color: actor.color || defaultColor,
    ignoreWhenMissing: true
  }),
  create: (base) => ({
    name: base.name,
    type: SupportingActorType.ASSIGNED_BY_SUBTASK,
    color: base.color,
    ignoreWhenMissing: true
  }),
  isComplete: () => true,
  toActor: (state, key) => ({
    type: SupportingActorType.ASSIGNED_BY_SUBTASK,
    name: state.name,
    key,
    color: state.color,
    ignoreWhenMissing: true
  }),
  Fields: SubtaskActorFields
};
